import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-worktype-grid',
  templateUrl: './worktype-grid.component.html',
  styleUrls: ['./worktype-grid.component.css']
})
export class WorktypeGridComponent implements OnInit {

  title = "Type of Work List";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master/work-type/worktype-grid/worktype-grid.component.ts